export enum ProvisioningStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
}
